export default "__VITE_ASSET__3d554f80__"